    import {createAsyncThunk} from "@reduxjs/toolkit";
import {client} from "../../_api/client";

export const GROUPS = "groups"

export const getGroups = createAsyncThunk(
    `${GROUPS}/getGroups`,
    async () => {
        const response = await client.get('/v2/groups/getAllTeacherGroupsWithStudents')
        return response.data
    }
)

export const getGroupById = createAsyncThunk(
    `${GROUPS}/getGroupById`,
    async (id) => {
        const response = await client.get(`/v2/groups/${id}`)
        return response.data
    }
)

export const saveGroup = createAsyncThunk(
    `${GROUPS}/saveGroup`,
    async (body) => {
        const response = await client.post(`/v2/groups`, body)
        return response.data
    }
)

export const deleteGroup = createAsyncThunk(
    `${GROUPS}/deleteGroup`,
    async (id) => {
        const response = await client.get(`/v2/groups/deleteGroup/${id}`)
        return response.data
    }
)

export const changeState = createAsyncThunk(
    `${GROUPS}/changeState`,
    async (request) => {
        const {type, lessonId} = request;
        let link = `/lesson/${type}/${lessonId}`

        const response = await client.get(link)
        return response.data
    }
)

export const closeLesson = createAsyncThunk(
    `${GROUPS}/changeState`,
    async (request) => {
        const {lessonId, body} = request;

        const response = await client.post(`/lesson/close/${lessonId}`, body)
        return response.data
    }
)

export const getLog = createAsyncThunk(
    `${GROUPS}/getLog`,
    async (id) => {
        const response = await client.get(`/visitLog/${id}`)
        return response.data
    }
)

export const saveAllVisits = createAsyncThunk(
    `${GROUPS}/saveAllVisits`,
    async (body) => {
        const response = await client.post(`/visitLog/saveAll`, body)
        return response.data
    }
)

export const saveStudent = createAsyncThunk(
    `${GROUPS}/saveStudent`,
    async (body) => {
        const response = await client.post(`/user/student`, body)
        return response.data
    }
)

export const getHomework = createAsyncThunk(
    `${GROUPS}/getHomeworks`,
    async (groupId) => {
        const response = await client.get(`/hw/mental/${groupId}`)
        return response.data
    }
)

export const getHomeworkByGroupIdAndUserId = createAsyncThunk(
    `${GROUPS}/getHomeworkById`,
    async (body) => {
        const {groupId, userId} = body
        const response = await client.get(`/hw/mental/${groupId}/${userId}`)
        return response.data
    }
)

export const saveHW = createAsyncThunk(
    `${GROUPS}/saveHW`,
    async (body) => {
        const response = await client.post(`/hw/mental`, body)
        return response.data
    }
)

export const updateHW = createAsyncThunk(
    `${GROUPS}/saveHW`,
    async (body) => {
        const response = await client.put(`/hw/mental`, body)
        return response.data
    }
)

export const transferStudent = createAsyncThunk(
    `${GROUPS}/transferStudent`,
    async (body) => {
        const response = await client.post(`/student/transfer`, body)
        return response.data
    }
)

export const deleteStudentFromGroup = createAsyncThunk(
    `${GROUPS}/deleteStudentFromGroup`,
    async ({studentId, groupId}) => {
        const response = await client.get(`/student/${studentId}/fromGroup/${groupId}`)
        return response.data
    }
)